const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */

  /* Default Advanced Settings */

  throttleEnabled: {
    value: false, // We want to default to true on render, but never compare the default
  },
  subscribeToAllLog: {
    value: true, // We want to default to true on render, but never compare the default
  },

  onePasswordName: {
    value: '',
  },

  availableContents: {
    value: 'AUDIT_EVENTS,ITEM_USAGES,SIGN_IN_ATTEMPTS',
  },
  onePasswordThrottleEnabled: {
    value: undefined,
  },
  overrideSource: {
    value: '',
  },
  pollingInterval: {
    value: 5,
  },
  contentTypes: {
    value: '',
  },
  onePasswordStoreFullMessage: {
    value: false, // We want to default to true on render, but never compare the default
  },
};

export default DEFAULT_SETTINGS;
